module.exports = __webpack_public_path__ + "static/5-df39765a263aa0e139a6c8df34415f4b.jpg";